import DEFAULT_ICON from "../assets/images/logo.png";
//@ts-ignore
import NOTIFICATION_SOUND from "../assets/music/notification.mp3";
import { getFullName } from "./shared";

const APP_NAME = "Kelu AI";

const playNotificationSound = () => {
  try {
    const audio = new Audio(NOTIFICATION_SOUND);
    audio.volume = 0.5; // 0.0 to 1.0
    audio.play().catch((err) => {
      console.warn("Could not play notification sound:", err);
    });
  } catch (err) {
    console.warn("Audio error:", err);
  }
};

export const requestNotificationPermission = async () => {
  try {
    if (!("Notification" in window)) {
      console.warn("This browser does not support notifications");
      return false;
    }

    if (Notification.permission === "default") {
      const permission = await Notification.requestPermission();
      return permission === "granted";
    }

    return Notification.permission === "granted";
  } catch (error) {
    console.log(
      "🚀 ~ notificationService.js ~ requestNotificationPermission ~ error:",
      error,
    );
  }
};

export const showNotification = ({
  title,
  body,
  icon,
  onClick,
  sound = true,
}) => {
  try {
    if (!("Notification" in window)) return;
    if (Notification.permission !== "granted") return;

    // 🔊 Play sound manually
    if (sound) {
      playNotificationSound();
    }

    const notification = new Notification(`${APP_NAME} • ${title}`, {
      body,
      icon: icon || DEFAULT_ICON,
      badge: DEFAULT_ICON,
    });

    notification.onclick = () => {
      window.focus();
      onClick?.();
      notification.close();
    };
  } catch (error) {
    console.log(
      "🚀 ~ notificationService.js ~ showNotification ~ error:",
      error,
    );
  }
};

export const showMessageNotification = (data, onClick) => {
  try {
    const senderName = getFullName(data?.sender);

    showNotification({
      title: senderName || "New Message",
      body: data?.textWithMentions || "You have a new message",
      icon: data?.sender?.avatar || DEFAULT_ICON,
      sound: true,
      onClick,
    });
  } catch (error) {
    console.log(
      "🚀 ~ notificationService.js ~ showMessageNotification ~ error:",
      error,
    );
  }
};
